import axios from "axios";

const producao =
  window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
const url = producao
  ? "https://apiv2.motorfiscal.com.br:2024"
  : "https://apiv2homolog.motorfiscal.com.br";

export async function getNfseOcr(
  dataIni = "",
  dataFim = "",
  cnpj = "",
  verificado = "",
  status_ocr = ""
) {
  try {
    const response = await axios.get(
      `${url}/valida-ocr?dataIni=${dataIni}&dataFim=${dataFim}&cnpj=${cnpj}&verificadoOcr=${verificado}&statusOcr=${status_ocr}`
    );
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function saveOcr(nfseOcr, id_usuario) {
  try {
    const response = await axios.put(`${url}/verificaNfse`, {
      nfseOcr,
      _id: nfseOcr._id,
      id_usuario: id_usuario,
    });
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function verifyOcr(id, id_usuario) {
  console.log(id_usuario);
  try {
    const response = await axios.post(`${url}/verificaNfse`, {
      _id: id,
      id_usuario: id_usuario,
    });
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function verifyDuplicate(
  numero_nota,
  cod_verificador,
  cnpj_prestador,
  codMun,
  _id,
  id_usuario
) {
  try {
    const response = await axios.post(`${url}/verifica-duplicidade`, {
      numero_nota: numero_nota,
      cod_verificador: cod_verificador,
      cnpj_prestador: cnpj_prestador,
      codMun: codMun,
      _id: _id,
      id_usuario: id_usuario,
    });
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function denyOcr(id, state, id_usuario) {
  try {
    const response = await axios.post(
      `${url}/alterar_status_processamento/${state}`,
      { _id: id, id_usuario: id_usuario }
    );
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function getFileOcr(id) {
  try {
    const response = await axios.get(`${url}/busca-pdf/${id}`);
    return response.data;
  } catch (err) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/domain/notas/nfseOcr/NfseOcrService.js